module.exports = __webpack_public_path__ + "static/social-media-image-0aac0f296159ef45ddec408f01543e8c.jpg";